import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67ea1d0d")

_pushScopeId("data-v-67ea1d0d")
const _hoisted_1 = { class: "pan-info" }
const _hoisted_2 = { class: "pan-info-roles-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    style: {zIndex: _ctx.zIndex, height: _ctx.height, width: _ctx.width},
    class: "pan-item"
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _createVNode("div", {
      style: {backgroundImage: `url(${_ctx.image})`},
      class: "pan-thumb"
    }, null, 4)
  ], 4))
})